import React from "react";
import "./AppliedFilterChips.scss";

/**
 * Presentational bar showing one removable chip per applied grid filter.
 * Renders nothing when there are no chips.
 * @param {{ chips: Array<{colId:string,label:string,count:number,values:string[]}>, onRemove: (colId:string) => void }} props
 */
export const AppliedFilterChips = ({ chips, onRemove }) => {
    if (!chips?.length) return null;

    return (
        <div className="applied-filters-bar" role="region" aria-label="Applied filters">
            <span className="applied-filters-label">Filters:</span>
            {chips.map((chip) => (
                <div key={chip.colId} className="applied-filter-chip">
                    <span className="applied-filter-chip-name">{chip.label}</span>
                    {chip.count > 0 && (
                        <span
                            className="applied-filter-chip-count"
                            tabIndex={0}
                            aria-label={`${chip.count} selected in ${chip.label}: ${chip.values.join(", ")}`}
                        >
                            {chip.count}
                            <span className="applied-filter-tip" role="tooltip">
                                <span className="applied-filter-tip-title">{chip.label} selected</span>
                                {chip.values.map((value, index) => (
                                    <span key={`${chip.colId}-${index}`} className="applied-filter-tip-row">
                                        {value}
                                    </span>
                                ))}
                            </span>
                        </span>
                    )}
                    <button
                        type="button"
                        className="applied-filter-chip-remove"
                        aria-label={`Remove ${chip.label} filter`}
                        onClick={() => onRemove(chip.colId)}
                    >
                        ×
                    </button>
                </div>
            ))}
        </div>
    );
};

export default AppliedFilterChips;
